<form [formGroup]="timezoneForm" (ngSubmit)="updateTimezone()" (keydown.enter)="$event.preventDefault()" class="is-fullheight">
  <lay-panel class="flex-column">
    <lay-panel-content>
      <lay-panel-block size="large" styleClass="side-borderless" class="is-borderless has-border-bottom">
        <div class="is-block is-fullwidth">
          <app-input-label>{{ 'common-app.__COM_SETTINGS_TIMEZONE' | LANG }}</app-input-label>
          <app-input-text
            formControlName="timezone"
            updateOn="change"
            [placeholder]="'e.g. Europe, Paris'">
          </app-input-text>
        </div>
      </lay-panel-block>

      @if (results$ | async; as results) {
        @for (timezone of results; track timezone) {
          <lay-panel-block
            size="default"
            styleClass="dropdown-line side-borderless"
            (click)="selectTimezone(timezone)">
            <app-text class="title is-6" [text]="timezone"></app-text>
            <app-single-selection-icon class="is-align-end" [selected]="isSelectedTimezone(timezone)"></app-single-selection-icon>
          </lay-panel-block>
        }
        @if (results.length === 0) {
          <lay-panel-block size="small" transparent>
            <app-text class="title is-6" [text]="'common-settings.__COM_SEARCH_NO_RESULTS' | LANG"></app-text>
          </lay-panel-block>
        }
      }
    </lay-panel-content>
    @if (selectedTimezone !== oldTimezone) {
      <lay-panel-footer>
        <lay-button class="is-flex-button">
          <button type="submit" class="is-primary-button" [ngClass]="{'is-loading': confirmLoader.loading$ | async}">
            <app-text [text]="'common-app.__CONFIRM' | LANG"></app-text>
          </button>
        </lay-button>
      </lay-panel-footer>
    }

  </lay-panel>
</form>
